import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import { isEmpty } from "lodash";

import { SignInForm } from "../Forms/Auth";
import { SignInCompaniesForm } from "../Forms/Auth";
import AuthContainer from "../../modules/auth/containers/Auth";
import withUnAuth from "./withUnAuth";

const isNordicrouting = window.location.origin.includes("nordicrouting.se");

const SignInPage = ({ auth, detailCode, doSignIn, statusDetailCode, setRedirectUrl }) => {
  const { companies: comp } = auth;
  const [paramsLogin, setParamsLogin] = useState("");
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    if (auth.inviteCode && statusDetailCode === "failed") {
      setRedirectUrl(null);
    }
  }, [statusDetailCode]);

  useEffect(() => {
    if (comp) {
      setCompanies(comp);
    }
  }, [comp]);

  const renderSignInForm = () => (
    <SignInForm setParamsLogin={setParamsLogin} doSignIn={doSignIn} detailCode={detailCode} />
  );

  return (
    <div className="SignInPage">
      {companies.length > 0 ? (
        <SignInCompaniesForm companies={companies} setCompanies={setCompanies} paramsLogin={paramsLogin} />
      ) : !isEmpty(detailCode) ? (
        renderSignInForm()
      ) : (
        <Row justify="center">
          {!isNordicrouting ? (
            <>
              <Col xs={0} sm={0} md={12}>
                <div
                  className="LeftImg"
                  style={{
                    backgroundImage: "url('/login-logo.jpg')",
                    backgroundSize: "cover",
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={12}>
                {renderSignInForm()}
              </Col>
            </>
          ) : (
            <Col xs={24} sm={24} md={{ span: 12, offset: 1 }}>
              {renderSignInForm()}
            </Col>
          )}
        </Row>
      )}
    </div>
  );
};

export default withUnAuth(AuthContainer(SignInPage));
